module.exports = __webpack_public_path__ + "static/media/plusko.9b08278346507cef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/plusko.svg
// module id = 1364
// module chunks = 0